<template>
  <div class="visit-record-detail-container">
    <div class="page-header">
      <div class="page-title-block">
        <h2>回访记录详情</h2>
        <p class="page-subtitle">一次农药/肥料使用后的效果跟踪与问题记录</p>
      </div>
      <div class="header-actions">
        <el-button @click="$router.back()">返回</el-button>
        <el-button type="primary" @click="handleEdit">编辑</el-button>
      </div>
    </div>

    <el-card v-loading="loading">
      <div v-if="record && record.id" class="content">
        <div class="meta">
          <div class="meta-item">
            <label>ID:</label>
            <span>#{{ record.id }}</span>
          </div>
          <div class="meta-item">
            <label>客户:</label>
            <span>{{ record.customer ? record.customer.name : '-' }}</span>
            <el-button
              v-if="record.customer && record.customer.id"
              type="text"
              @click="handleViewCustomer(record.customer.id)"
            >
              查看客户
            </el-button>
          </div>
          <div class="meta-item">
            <label>记录人:</label>
            <span>{{ record.recorder ? record.recorder.name : '-' }}</span>
          </div>
          <div class="meta-item">
            <label>记录时间:</label>
            <span>{{ formatDate(record.recordTime) }}</span>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="fields">
          <div class="field">
            <h4>用药时间</h4>
            <div class="field-value">{{ formatDate(record.medicineTime) || '-' }}</div>
          </div>
          <div class="field">
            <h4>回访时间</h4>
            <div class="field-value">{{ formatDate(record.visitTime) || '-' }}</div>
          </div>
          <div class="field">
            <h4>用药记录</h4>
            <div class="field-value pre">{{ record.medicineRecord || '-' }}</div>
          </div>
          <div class="field">
            <h4>用肥记录</h4>
            <div class="field-value pre">{{ record.fertilizerRecord || '-' }}</div>
          </div>
          <div class="field">
            <h4>效果观察记录</h4>
            <div class="field-value pre">{{ record.effectObservation || '-' }}</div>
          </div>
          <div class="field">
            <h4>问题备注</h4>
            <div class="field-value pre">{{ record.problemNotes || '-' }}</div>
          </div>
        </div>

        <div class="images" v-if="record.images && record.images.length">
          <el-divider></el-divider>
          <h4>回访图片</h4>
          <div class="image-grid">
            <el-image
              v-for="(url, idx) in record.images"
              :key="`${url}-${idx}`"
              :src="url"
              fit="cover"
              :preview-src-list="record.images"
              class="image"
            ></el-image>
          </div>
        </div>
      </div>
      <div v-else class="empty">未找到回访记录</div>
    </el-card>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'VisitRecordDetail',
  data() {
    return {
      loading: false,
      record: null
    }
  },
  computed: {
    recordId() {
      return parseInt(this.$route.params.id)
    }
  },
  mounted() {
    this.loadRecord()
  },
  methods: {
    loadRecord() {
      if (!this.recordId) return
      this.loading = true
      request.get(`/visit-records/${this.recordId}`)
        .then(res => {
          this.record = res.data || res
        })
        .catch(error => {
          console.error('加载回访记录详情失败:', error)
          this.$message.error('加载回访记录详情失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    handleEdit() {
      if (!this.recordId) return
      this.$router.push(`/visit-records/edit/${this.recordId}`)
    },
    handleViewCustomer(customerId) {
      this.$router.push(`/customers/${customerId}`)
    }
  }
}
</script>

<style scoped>
.visit-record-detail-container {
  width: 100%;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  padding: 10px 4px 4px;
}

.page-title-block h2 {
  margin: 0;
  color: #0f8f59;
  font-size: 22px;
}

.page-subtitle {
  margin-top: 4px;
  font-size: 12px;
  color: #80848f;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.content {
  width: 100%;
}

.meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.meta-item label {
  color: #606266;
  font-weight: 600;
}

.fields .field {
  margin-bottom: 14px;
}

.fields h4 {
  margin: 0 0 6px 0;
  color: #606266;
}

.field-value {
  color: #303133;
  line-height: 1.6;
}

.field-value.pre {
  white-space: pre-wrap;
  word-break: break-word;
  background: #fafafa;
  border: 1px solid #ebeef5;
  padding: 10px;
  border-radius: 6px;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.image {
  width: 100%;
  height: 120px;
  border-radius: 6px;
  overflow: hidden;
}

.empty {
  color: #909399;
  text-align: center;
  padding: 20px 0;
}

@media (max-width: 768px) {
  .visit-record-detail-container {
    padding: 0 10px;
  }
  .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .header-actions {
    justify-content: flex-end;
  }
}
</style>

